module.exports = __webpack_public_path__ + "img/border-vert.394c7ea0.png";